import React from 'react';
import { Link } from 'react-router-dom';

interface AuthCardLayoutProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  headerLinkPrompt: string;
  headerLinkAction: string;
  headerLinkHref: string;
  footerNotice?: React.ReactNode;
  children: React.ReactNode;
}

export const AuthCardLayout: React.FC<AuthCardLayoutProps> = ({
  title,
  subtitle,
  icon,
  headerLinkPrompt,
  headerLinkAction,
  headerLinkHref,
  footerNotice,
  children,
}) => {
  return (
    <div className="min-h-screen bg-[#09090B] text-[#FAFAFA] flex flex-col justify-between selection:bg-indigo-600 selection:text-white">
      {/* Header */}
      <header className="border-b border-zinc-800/80 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-linear-to-tr from-indigo-600 to-violet-500 flex items-center justify-center font-black text-white text-base shadow-md shadow-indigo-500/20">
            C
          </div>
          <span className="font-bold text-base text-white tracking-tight">
            Conversora Partners
          </span>
        </Link>
        <Link
          to={headerLinkHref}
          className="text-xs font-medium text-zinc-400 hover:text-white transition flex items-center gap-1"
        >
          <span>{headerLinkPrompt}</span>
          <span className="text-indigo-400 font-semibold">{headerLinkAction}</span>
        </Link>
      </header>

      {/* Main Container */}
      <main className="flex-1 flex items-center justify-center p-4 sm:p-6">
        <div className="w-full max-w-md bg-zinc-900/70 border border-zinc-800/90 rounded-2xl p-6 sm:p-8 shadow-2xl backdrop-blur-xl">
          <div className="text-center mb-6">
            <div className="w-11 h-11 mx-auto mb-3 rounded-xl bg-indigo-600/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400">
              {icon}
            </div>
            <h1 className="text-2xl font-bold text-white tracking-tight">{title}</h1>
            <p className="text-xs sm:text-sm text-zinc-400 mt-1">{subtitle}</p>
          </div>

          {children}

          {/* Footer note */}
          <div className="mt-6 pt-5 border-t border-zinc-800/80 text-center text-xs text-zinc-500">
            {footerNotice || (
              <>
                <span>By continuing, you agree to Conversora's </span>
                <span className="text-zinc-400">Partner Program Terms</span>.
              </>
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-800/80 py-4 px-6 text-center text-xs text-zinc-500 font-medium">
        © {new Date().getFullYear()} Conversora Inc. • Conversora Partner Program
      </footer>
    </div>
  );
};
